<template>
  <div class="first-pop">
    <a-modal
      v-model="ismodal"
      :centered="true"
      :footer="null"
      :closable="false"
      :maskClosable="false"
      @cancel="cancelFn"
      width="469px"
    >
      <div class="modal-box">
        <div class="closeIcon"><a-icon class="icon" type="close" @click.native="ismodal = false" /></div>

        <!-- <div class="alertTime">{{ goodNews.alertTime }}</div> -->
        <!-- <span v-relativeTime="time"></span> -->
        <div class="content">{{ goodNews.messageContent }}</div>
        <div :class="ext.attendants&&ext.attendants.length>1 ?'userinfo justify-around':'userinfo justify-center'" v-if="ext.attendants&&ext.attendants.length>0">
          <div class="userinfo-left" v-for="(item,index) in ext.attendants" :key="index">
            <img
              class="avatar"
              width="120"
              style="border-radius: 50%"
              :src="item && item.accendantAvatar ? item.accendantAvatar : imgUrl"
              alt="头像"
            />
            <div class="name" v-if="item && item.accendantNickName">{{ item.accendantNickName }}</div>
          </div>

          <!-- <div class="userinfo-right">
            <img
              class="avatar"
              width="120"
              style="border-radius: 50%"
              :src="ext && ext.laccendantAvatar ? ext.laccendantAvatar : imgUrl"
              alt="头像"
            />
            <div class="name" v-if="goodNews && goodNews.ext && ext">{{ ext.laccendantNickName }}</div>
            <div class="price" v-if="goodNews && goodNews.ext && ext">&yen;{{ ext.laccendantRentExpense }}</div>
          </div> -->
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    goodNews: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      ismodal: false,
      // ismodal: true,
      time: new Date(),
      imgUrl: require('@/assets/home-imgs/头像.svg'),
      ext: {},
    }
  },

  methods: {
    modalFn() {
      if (this.goodNews.messageType) {
        this.ismodal = true
      }
    },
    cancelFn() {
      this.$emit('handleClose', {})
    },
    getExtObj() {
      if (this.goodNews && this.goodNews.ext) {
        this.ext = JSON.parse(this.goodNews.ext.replace(/'\'/g, ''))
        console.log(this.ext, '-----this.ext')
      }
    },
  },

  watch: {
    goodNews: {
      handler: function () {
        this.getExtObj()
        this.modalFn()
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="less" scoped>
 .justify-around{
      justify-content: space-around;
 }
  .justify-center{
      justify-content: center;
 }
.modal-box {
  height: 750px;
  background: url('./imgs/goodNews.png') no-repeat;
  background-size: contain;
  position: relative;
  .closeIcon {
    text-align: right;
    padding-right: 10px;
    padding-top: 10px;
    .icon {
      font-size: 20px;
      cursor: pointer;
    }
  }
  .content {
    // border: 1px solid rgb(202, 192, 192);
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    width: 300px;
    color: #eed7a3;
    position: absolute;
    top: 570px;
    left: 50%;
    transform: translateX(-50%);
  }
  .userinfo {
    margin-top: 200px;
    display: flex;
    .userinfo-left,
    .userinfo-right {
      position: relative;
      .avatar {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
      .name {
        // border: 1px solid red;
        width: 100px;
        text-align: center;
        color: #eed7a3;
        font-size: 20px;
        font-weight: 700;
        position: absolute;
        top: 150px;
        left: 50%;
        transform: translateX(-50%);
      }
      .price {
        color: #eed7a3;
        font-size: 36px;
        font-weight: 700;
        position: absolute;
        top: 200px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .big {
    font-weight: 700;
    font-size: 16px;
    color: var(--ThemeColor);
  }
  .goList {
    color: var(--ThemeColor);
    cursor: pointer;
  }
}
/deep/.ant-modal-body {
  padding: 0;
}
/deep/.ant-modal-header {
  background-color: #df2220;
  border-bottom: none;
}
</style>